<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <!-- HEADER -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "Affiliation Payments Manager" | transloco }}</span>
        <h2 class="bb-page-title">{{ "Affiliation Payments Manager" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "Order By" | transloco }}</p>
      </div>

      <div class="bb-header-actions noPrint">

        <button (click)="exportToExcel()" class="bb-btn bb-btn-secondary">
          {{ "export to excel" | transloco }}
        </button>

        <div *ngIf="isAdmin" class="dropdown">
          <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
            {{ "Order By" | transloco }}
          </button>

          <ul class="dropdown-menu">
            <li>
              <a class="dropdown-item" (click)="getAllPaymentsData(10,1)">
                {{ "All" | transloco }}
              </a>
            </li>

            <li *ngFor="let el of allUsers">
              <a class="dropdown-item" (click)="userFilter(el.id)">
                {{ el.last_name }}
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>

    <!-- SUMMARY -->
    <div class="finance-summary-grid">

      <div class="finance-summary-card finance-summary-card-net">
        <div class="finance-summary-card-head">
          <h6>{{ 'إجمالي الطلبات' | transloco }}</h6>
        </div>
        <h3 class="bb-text-navy">
          {{ totalAllOrders }}
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'إجمالي العمولة' | transloco }}</h6>
        </div>
        <h3 class="finance-value-success">
          {{ totalAllDue | number:'1.2-2' }} {{ 'EGP' | transloco }}
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'المكتمل' | transloco }}</h6>
        </div>
        <h3 class="finance-value-success">
          {{ totalCompleted }}
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'المعلق' | transloco }}</h6>
        </div>
        <h3 class="finance-value-danger">
          {{ totalPending }}
        </h3>
      </div>

    </div>

    <!-- TABLE -->
    <div class="bb-table-card">

      <div class="bb-empty-state" *ngIf="noData">
        <app-nodata></app-nodata>
      </div>

      <div class="bb-table-scroll" *ngIf="!noData">
        <table mat-table id="afiliationpaymenttable" [dataSource]="dataSource" class="bb-table table-custom">

          <!-- Order By -->
          <ng-container matColumnDef="order_by">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Order By" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.user_last_name }}
            </td>
          </ng-container>

          <!-- Invoice -->
          <ng-container matColumnDef="order_id">
            <th mat-header-cell *matHeaderCellDef>
              {{ "invoice" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              #{{ element.order_id }}
            </td>
          </ng-container>

          <!-- Due -->
          <ng-container matColumnDef="due">
            <th mat-header-cell *matHeaderCellDef>
              {{ "due" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="bb-price">
                {{ element.due }}
              </span>
            </td>
          </ng-container>

          <!-- Requested -->
          <ng-container matColumnDef="requested">
            <th mat-header-cell *matHeaderCellDef>
              {{ "requested by user" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <i class="fa-solid" [ngClass]="element.requested ? 'fa-check bb-text-success' : 'fa-xmark bb-text-danger'">
              </i>
            </td>
          </ng-container>

          <!-- Completed -->
          <ng-container matColumnDef="complated">
            <th mat-header-cell *matHeaderCellDef>
              {{ "complatedpayment" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <i class="fa-solid" [ngClass]="element.complated ? 'fa-check bb-text-success' : 'fa-xmark bb-text-danger'">
              </i>
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="bb-actions-th"></th>
            <td mat-cell *matCellDef="let element" class="bb-actions-td">
              <div *ngIf="!element.complated" class="dropdown bb-action-dropdown">
                <button class="bb-icon-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>

                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" (click)="paymentCompleted(element.id,element.due,element.user_last_name)">
                      {{ "payment done" | transloco }}
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
      </div>

      <!-- Pagination -->
      <mat-paginator
        class="bb-paginator"
        [length]="stockTotal"
        [pageSize]="10"
        (page)="onPaginateChange($event)"
      >
      </mat-paginator>

    </div>

  </div>
</section>